import React, { useState, useEffect } from "react";
import { FaSmile, FaMeh, FaFrown, FaTimes } from "react-icons/fa";

const NotasEditModal = ({ nota, onClose, onSave, showNotification }) => {
  const [calificacion, setCalificacion] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const esPreescolar = !!nota?.simbolo_carita;

  useEffect(() => {
    if (nota) {
      setCalificacion(nota.simbolo_carita || nota.calificacion || "");
    }
  }, [nota]);

  const handleSave = async () => {
    if (!calificacion && !esPreescolar) {
      showNotification({ type: "error", message: "La calificación no puede estar vacía." });
      return;
    }

    setIsLoading(true);
    try {
      await onSave(nota.id, { calificacion });
      showNotification({ type: "success", message: "Nota actualizada correctamente." });
      onClose();
    } catch (error) {
      showNotification({ type: "error", message: "Error al actualizar la nota." });
    } finally {
      setIsLoading(false);
    }
  };

  if (!nota) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-xl font-semibold">Editar Nota</h3>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-700">
            <FaTimes size={20} />
          </button>
        </div>

        <div className="mb-4">
          <p className="text-sm text-gray-600 mb-2">
            <strong>Estudiante:</strong> {nota.first_name} {nota.second_name || ""} {nota.first_surname || ""} {nota.second_surname || ""}
          </p>
          <p className="text-sm text-gray-600 mb-2">
            <strong>Asignatura:</strong> {nota.asignatura_nombre}
          </p>
          <p className="text-sm text-gray-600 mb-4">
            <strong>Periodo:</strong> {nota.periodo_id}
          </p>
        </div>

        <div className="mb-6">
          <label className="block mb-2 font-medium">Calificación</label>
          {esPreescolar ? (
            <div className="flex space-x-4 justify-center">
              {[
                { value: "feliz", icon: <FaSmile size={40} />, color: "text-green" },
                { value: "contento", icon: <FaSmile size={40} />, color: "text-main-blue" },
                { value: "intermedio", icon: <FaMeh size={40} />, color: "text-yellow-500" },
                { value: "triste", icon: <FaFrown size={40} />, color: "text-red-500" },
              ].map(({ value, icon, color }) => (
                <button
                  key={value}
                  type="button"
                  onClick={() => setCalificacion(value)}
                  className={`flex flex-col items-center space-y-1 p-3 rounded-lg ${
                    calificacion === value ? "bg-blue-200" : "hover:bg-gray-100"
                  }`}
                >
                  <span className={color}>{icon}</span>
                </button>
              ))}
            </div>
          ) : (
            <input
              type="number"
              value={calificacion}
              onChange={(e) => setCalificacion(e.target.value)}
              className="w-full p-2 border border-gray-300 rounded"
              min="0"
              max="5"
              step="0.1"
            />
          )}
        </div>

        <div className="flex gap-3 justify-end">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-300 text-gray-700 rounded hover:bg-gray-400"
            disabled={isLoading}
          >
            Cancelar
          </button>
          <button
            onClick={handleSave}
            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
            disabled={isLoading}
          >
            {isLoading ? "Guardando..." : "Guardar"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotasEditModal;
